import { IFirestoreModel, Timestamp } from '@principle-theorem/shared';
import { KnowledgeBasePushStatus } from './ai-receptionist-knowledge-base';
import { OvieHealthSettingsSection } from './ovie/settings/settings-action';

export interface IAIReceptionistSettings extends IFirestoreModel {
  practice?: string;
  greeting?: string;
  messages?: string;
  callHandling?: string;
  routing?: string;
  communications?: string;
  bookingCatalog?: string;
  bookingPolicies?: string;
  sectionEtags?: Partial<Record<OvieHealthSettingsSection, string>>;
  lastPushAt?: Timestamp;
  lastPushStatus?: KnowledgeBasePushStatus;
}
